import React, { useEffect, useState } from "react";
import "../CSS/Services3.css";
import axios from "axios";

const Services3 = ({ title }) => {
  const [services, setServices] = useState([]);
  const [currentSubtitleIndex, setCurrentSubtitleIndex] = useState(0);

  useEffect(() => {
    const fetchFilteredServices = async () => {
      try {
        const response = await axios.get(
          `https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getServicesSection3`,
          {
            params: { title },
          }
        );
        setServices(response.data);
        console.log("responseofservice3:", response.data);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchFilteredServices();
  }, [title]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSubtitleIndex((prevIndex) =>
        services[0]?.subtitles3
          ? (prevIndex + 1) % services[0].subtitles3.length
          : 0
      );
    }, 8000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, [services]);

  return (
    <div className="containerservices5">
      <div className="shape-blob" />
      <div className="shape-blob one" />

      {services.map((service, index) => (
        <div key={index} className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-10 col-lg-8">
              <div className="header-section">
                <h2 className="title blackthemegradient">{service.title}</h2>
                <p className="description text-white">{service.description}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              {service.subtitles3.length > 0 && (
                <div className="tips-section">
                  <div className="tips-section__image">
                    <img
                      src={
                        service.subtitles3[currentSubtitleIndex]?.subimage || ""
                      }
                      alt={
                        service.subtitles3[currentSubtitleIndex]?.subtitle || ""
                      }
                      className="subtitle-image"
                    />
                  </div>
                  <div className="tips-section__content glassmorphism">
                    <h1 className="tips-heading mb-4 text-center blackthemegradient">
                      {service.subtitles3[currentSubtitleIndex]?.subtitle}
                    </h1>
                    <p className="tips-description text-white">
                      {
                        service.subtitles3[currentSubtitleIndex]
                          ?.subdescription
                      }
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services3;
